
import React, { memo } from 'react';
import { getRandomColor } from '../constants';

interface AccountSelectionListProps {
    list: any[];
    selectedSocialMedia: any;
    onSelect: (item: any) => void;
    onCancel?: () => void;
}

export const AccountSelectionList = memo(({ list, selectedSocialMedia, onSelect, onCancel }: AccountSelectionListProps) => {
    return (
        <div className='py-4 px-2 min-h-[80vh] flex flex-col justify-center items-center'>
            <h2 className="text-xl text-center font-semibold mb-4">
                Please select the {['Youtube'].includes(selectedSocialMedia?.NAME) ? "channel" : ['Google Business', 'WhatsApp Business'].includes(selectedSocialMedia?.NAME) ? "Business Account" : "page"}.
            </h2>
            <div className="space-y-4 h-[300px] overflow-auto w-full max-w-2xl px-4">
                {list?.map((element, index) => {
                    const isStandardList = ['Google Business', 'Youtube', 'WhatsApp Business'].includes(selectedSocialMedia?.NAME);
                    // Unified accessors
                    const title = isStandardList ? (element?.snippet?.title || element?.title || element?.name) : element?.name;
                    const photoUrl = isStandardList ? (element?.snippet?.thumbnails?.default?.url || element?.photo_url) : element?.page_logo_url;
                    const likes = element?.page_likes;
                    const category = element?.category;

                    const firstLetter = title?.charAt(0).toUpperCase();
                    const randomColor = getRandomColor();

                    return (
                        <div key={"account_selection_" + index} className='flex justify-between gap-4 items-center bg-white p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow'>
                            <div className="flex items-center space-x-4">
                                <div className={`flex items-center justify-center w-10 h-10 text-white font-bold rounded-full overflow-clip ${randomColor}`}>
                                    {!!photoUrl ? (
                                        <img src={photoUrl} alt={'thumbnail'} className='object-cover w-10 h-10' />
                                    ) : (
                                        firstLetter
                                    )}
                                </div>
                                <div>
                                    <p className="font-medium">{title}</p>
                                    {!['Google Business', 'Youtube', 'WhatsApp Business'].includes(selectedSocialMedia?.NAME) && (
                                        <p className="text-sm text-gray-500">{likes} Likes · {category}</p>
                                    )}
                                </div>
                            </div>
                            <button
                                onClick={() => onSelect(element)}
                                className='text-primary-main font-semibold border border-solid py-1 px-3 rounded-lg hover:bg-neutral-50'
                                type="button"
                            >
                                Select
                            </button>
                        </div>
                    );
                })}
            </div>
            {onCancel && (
                <div className="mt-6 w-full px-4">
                    <button
                        onClick={onCancel}
                        className="w-full text-gray-600 font-semibold py-2 px-4 rounded-lg bg-gray-50 hover:bg-gray-100 border border-gray-200 transition-colors"
                        type="button"
                    >
                        Cancel
                    </button>
                </div>
            )}
        </div>
    );
});
